// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__kXlYa","footerBody":"Footer_footerBody__X2pve","footerLink":"Footer_footerLink__zoJJ6"};